import { render } from "./HomeView.vue?vue&type=template&id=0cd3e959&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0cd3e959&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd3e959"]])

export default __exports__